/**
 * PDF links open in a new tab. Asked for on 2026-08-27: *"sitede bizi pdf e
 * yönlendiren bir butona tıkladığımızda bu buton yeni bir sekmede açılsın"*.
 *
 * Every one of these destinations is a document rather than a page — the
 * e-book and report PDFs in the `website-documents` bucket — so a same-tab
 * click replaces the page the reader was on with a viewer they then have to
 * back out of, and on a phone the browser hands the file to a separate app and
 * the site is simply gone. Opening in a new tab leaves the page they were
 * reading exactly where it was.
 *
 * **Attributes, not JavaScript.** 117 of the 154 built documents never hydrate
 * (imported pages and posts are static HTML with no client bundle), so an
 * onClick handler would work on the written pages and quietly do nothing on the
 * majority of the site. `target`/`rel` are in the prerendered markup and work
 * everywhere, with or without a bundle.
 *
 * `rel="noopener noreferrer"` because `target="_blank"` otherwise hands the
 * opened document a live `window.opener` handle back to us.
 */
export function isPdfHref(href: string): boolean {
  // Query strings and fragments are stripped first: the bucket URLs carry
  // neither today, but a signed or anchored one (`file.pdf?token=…`, `#page=3`)
  // is the same file and would fail a naive `endsWith`.
  return /\.pdf$/i.test(href.split(/[?#]/, 1)[0])
}

/**
 * The anchor props for an href, spread at the link: `{...pdfLinkProps(href)}`.
 * Empty for everything that is not a PDF, so it is safe on any link and callers
 * do not have to ask the question twice.
 */
export function pdfLinkProps(href: string): { target?: '_blank'; rel?: string } {
  return isPdfHref(href) ? { target: '_blank', rel: 'noopener noreferrer' } : {}
}
